import UIComponent from "../../../ui/component";

export class PaymentErrorBlock extends UIComponent {
    constructor(element) {
        super(element);
        this.errorData = null;
    }

    init() {
        try {
            this.retryBtn = this.find(".payment-error-footer .btn-primary");
            this.closeBtn = this.find(".payment-error-footer .btn-secondary");

            if (this.retryBtn) {
                this.retryBtn.addEventListener("click", () => this.onRetryButtonClick());
            }

            if (this.closeBtn) {
                this.closeBtn.addEventListener("click", () => this.onCloseButtonClick());
            }
        } catch (error) {
            console.error("PaymentErrorBlock init error:", error);
        }
    }

    handlePaymentError(errorData) {
        this.errorData = errorData;    
        this.show();
    }

    show() {
        this.element.style.display = 'block';
    }

    hide() {
        this.element.style.display = 'none';
    }

    onRetryButtonClick() {
        if (this.errorData?.retryUrl) {
            window.location.href = this.errorData.retryUrl;
        } else {
            window.location.reload();
        }
    }

    onCloseButtonClick() {
        this.hide();
    }
}